import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CHECK_IN_MODEL} from "../Model/Model";
import {toast} from "react-toastify";
import {EquipmentCheckInOut} from "../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi";
import {errorMsg} from "../../../../../Apis/functions";
import {ACCESS_TYPE_MATERIAL_MODEL} from "../../../Contractors/Model/Models";


/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 01 de diciembre de 2025
 * Check-in modal controller hook.
 *
 * This module is dummy front-end logic. API calls are commented out and used only
 * as placeholders for integration. Returns state and handlers for a check-in modal form.
 *
 * @function CheckInModalApp
 * @param {Object} props
 * @param {Object} props.itemSelected - Optional selected item ID or data to load.
 * @returns {Object} Object containing state, setters, validators, and submit handler.
 */
export const CheckInModalApp = ({itemSelected, onHide}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [emptyFields, setEmptyFields] = useState(false);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const dataUser = user?.data;
    const [item, setItem] = useState(
        CHECK_IN_MODEL.set({
            userId: itemSelected?.userId,
            guardId: dataUser?.id,
            guardFullName: dataUser?.fullName,
            accessType: ACCESS_TYPE_MATERIAL_MODEL.ENTRY.name
    })); //CHECK_IN_MODEL
    const [selectedList, setSelectedList] = useState([]); // EQUIPMENT_MODEL

    /**
     * Validates and builds the DTO for check-in creation.
     * If validation fails, displays a warning.
     *
     * This is dummy front-end only. Submission is commented out.
     *
     * @function handleCreate
     */
    const handleCreate = () => {
        dispatch(EquipmentCheckInOut(item.toRegister(selectedList.map(e => ({id: e.id}))))).then(({payload:{data:{success, code}}})=>{
            if (success){
                toast.success(t('has_been_created_successfully'));
                onHide();
            }else errorMsg(code)
        });
    };

    return {
        t,
        selectedList,
        setSelectedList,
        item,
        setItem,
        handleCreate,
        emptyFields
    }

}
